import { pages } from './pages';
import { services } from './services';

export const primaryMenu = [
  pages.home,
  {
    url: '#',
    text: 'Services',
    disabled: true,
    menu: services,
  },
  {
    url: '#',
    text: 'About Us',
    disabled: true,
    menu: [
      {
        ...pages.about,
        text: 'Our Company',
        exact: true,
      },
      pages.history,
      pages.hseq,
      pages.managementTeam,
      pages.termsAndConditions,
    ],
  },
  {
    ...pages.csr,
    text: 'CSR',
  },
  pages.careers,
  pages.contact,
];

export const footerPrimaryMenu = [
  pages.jobs,
  pages.history,
  pages.hseq,
  pages.about,
  pages.termsAndConditions,
];

export const footerSecondaryMenu = [pages.construction, pages.manpower, pages.engineering];
